import { render, staticRenderFns } from "./ListByArticle.vue?vue&type=template&id=39e30545&"
import script from "./ListByArticle.vue?vue&type=script&lang=js&"
export * from "./ListByArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports